/**
 * Created by bartdecorte on 03/05/2017.
 */
import IndexPage from '../IndexPage';
import { modifierState } from '../../helpers/os';

class HomeIndex extends IndexPage {
  constructor() {
    super();
    this.bindKeys(this.keyBindings());
  }

  // Example to extend bindings
  keyBindings() {
    const bindings = super.keyBindings();
    return {
      ...bindings,
      // add more
    };
  }

  bindListeners() {
    super.bindListeners();
    $('.js-websites tr').on('click', (ev) => this.lRowClick(ev));
  }

  lRowClick(ev) {
    let cancel = ['a'];
    if (
      $(ev.target).is(cancel.join(', ')) ||
      $(ev.target).parents(cancel.join(', ')).length
    ) {
      return true;
    }

    let $elt =
      $(ev.target).get(0).tagName === 'TR'
        ? $(ev.target)
        : $(ev.target)
            .parents('tr')
            .first();
    const location = $elt
      .find('.js-row-click-action')
      .first()
      .attr('href');

    if (modifierState(ev)) {
      window.open(location, '_blank');
      return false;
    }

    window.location = location;
    return false;
  }
}

export default HomeIndex;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Home/HomeIndex.js